import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  getSupport,
  getSupportFetched,
  getError,
} from './support-data.reducer';
import { Support } from './models/support.model';

@Injectable()
export class SupportDataStore {
  constructor(private _store: Store<any>) {}

  getSupport(): Observable<Support> {
    return this._store.select(getSupport);
  }

  getSupportFetched(): Observable<boolean> {
    return this._store.select(getSupportFetched);
  }

  getError(): Observable<any[]> {
    return this._store.select(getError);
  }
}
